import { MessageCircle } from "lucide-react";

export const WhatsAppButton = () => {
  const whatsappUrl = "https://api.whatsapp.com/send?phone=5511910456805&text=Olá,%20gostaria%20de%20um%20orçamento";

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 group"
      aria-label="Fale conosco no WhatsApp"
    >
      <div className="h-14 w-14 lg:h-16 lg:w-16 bg-[#25D366] rounded-full flex items-center justify-center shadow-elegant hover:scale-105 transition-all duration-300 hover:shadow-xl">
        <MessageCircle className="h-7 w-7 lg:h-8 lg:w-8 text-white" />
      </div>
      
      {/* Tooltip */}
      <div className="absolute bottom-full right-0 mb-2 hidden group-hover:block animate-fadeIn">
        <div className="bg-foreground text-background px-3 py-1.5 rounded-lg text-sm whitespace-nowrap shadow-lg">
          Fale conosco
          <div className="absolute top-full right-4 w-0 h-0 border-l-4 border-r-4 border-t-4 border-l-transparent border-r-transparent border-t-foreground" />
        </div>
      </div>
    </a>
  );
};
